import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TitleCasePipe } from '@angular/common';

import { NewEquipmentService } from '../../services/new-equipment.service';
import { FooterService } from '../../services/footer.service';

import { catchError, map, of } from 'rxjs';
import { FooterLegalsComponent } from '../footer-legals/footer-legals.component';
import { HeadService } from '../../services/head.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, RouterLink, TitleCasePipe, FooterLegalsComponent],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  private newEquipmentService = inject(NewEquipmentService);
  private footerService = inject(FooterService);
  private headService = inject(HeadService);

  readonly year = new Date().getFullYear();

  activeDropdown = signal<string | null>(null);
  showAllFamilies = signal(false);

  newCategories = toSignal(
    this.newEquipmentService.getCategories().pipe(
      map((res) => res ?? []),
      catchError((err) => { console.error(err); return of([]); }),
    ),
    { initialValue: [] },
  );

  categoriesSpare = toSignal(
    this.footerService.getCategories().pipe(
      map((res) => res ?? []),
      catchError((err) => { console.error(err); return of([]); }),
    ),
    { initialValue: [] },
  );

  categoriesUsed = toSignal(
    this.headService.getCategoriesWithSubcategoriesUsedEquipment().pipe(
      catchError((err) => { console.error(err); return of([]); }),
    ),
    { initialValue: [] },
  );

  categoriesDS = toSignal(
    this.headService.getCategoriesDigitalSolutions().pipe(
      map((res) => res.results ?? []),
      catchError((err) => { console.error(err); return of([]); }),
    ),
    { initialValue: [] },
  );

  toggleDropdown(id: string): void {
    const isOpen = this.activeDropdown() === id;
    this.activeDropdown.set(isOpen ? null : id);
    if (!isOpen) this.showAllFamilies.set(false);
  }

  showMore(): void {
    this.showAllFamilies.set(true);
  }
}
